import { IContactEmailData, IContactPhoneNumberData } from "./ContactPhoneNumberData";

const defaultPhoneNumberData: IContactPhoneNumberData = {
  employeePrimaryPhone: "",
  employeePrimaryPhoneExtension: "",
  employeeMobilePhone: "",
};

export const defaultData: IContactEmailData = {
  employeeEmail: "",
  employeePhones: defaultPhoneNumberData
};

export enum ProgressBarSteps {
  VerifyEmail = "Verify Email",
  UpdatePhone = "Update Phone Number",
  Confirmation = "Confirmation",
}
